export default __webpack_public_path__ + "static/media/white_xpay_logo.9c570e10.svg";